import {createSlice} from '@reduxjs/toolkit';

const alertviewSlice = createSlice({
  name: 'alertview',
  initialState: {
    loading: true,
    vehiclesUnfiltered: [],
    vehicleSNDict: {},
    zonesDicts: {
      blocks: {},
      fields: {},
      regions: {},
      nonAcAreas: {},
    },
    geofencesDict: {},
    nonAcGeofencesDict: {},
    taskConfigDict: {},
    databaseUsers: [],
    sortMethod: 'occurrences',
  },
  reducers: {
    updateLoading(state, action) {
      state.loading = action.payload;
    },
    updateVehiclesUnfilteredData(state, action) {
      const vehiclesUnfiltered = action.payload;

      const vehicleSNDict = {};
      vehiclesUnfiltered.forEach((vehicle) => {
        vehicleSNDict[vehicle.serialNumber] = vehicle;
      });

      state.vehiclesUnfiltered = vehiclesUnfiltered;
      state.vehicleSNDict = vehicleSNDict;
    },
    updateZonesData(state, action) {
      const allZoneData = action.payload;

      state.zonesDicts = {
        blocks: allZoneData.blocks,
        fields: allZoneData.fields,
        regions: allZoneData.regions,
        nonAcAreas: allZoneData.nonAcAreas,
      };
    },
    updateGeofences(state, action) {
      state.geofencesDict = action.payload;
    },
    updateNonAcGeofences(state, action) {
      state.nonAcGeofencesDict = action.payload;
    },
    updateTaskConfigDict(state, action) {
      state.taskConfigDict = action.payload;
    },
    updateDatabaseUsers(state, action) {
      state.databaseUsers = action.payload;
    },
    updateSortMethod(state, action) {
      state.sortMethod = action.payload;
    },
  },
});

function getAlertsData() {
  return async (dispatch, getState) => {
    dispatch(alertviewSlice.actions.updateLoading(true));

    // const getAlertsDataRequest = fetch('/shopview/getAlertsData', {cache: 'no-store'});

    const getVehiclesUnfilteredRequest = fetch('/getVehiclesUnfiltered', {cache: 'no-store'});
    const getZonesRequest = fetch('/getZonesData?unfiltered=true', {cache: 'no-store'});
    const getTaskConfigsRequest = fetch('/getTaskConfigs', {cache: 'no-store'});
    const getDatabaseUsersRequest = fetch('/settings/getDatabaseUsers', {cache: 'no-store'});

    // Make all calls
    const [getVehiclesUnfilteredResponse, getZonesResponse, getTaskConfigsResponse, getDatabaseUsersResponse] =
      await Promise.all([
        getVehiclesUnfilteredRequest,
        getZonesRequest,
        getTaskConfigsRequest,
        getDatabaseUsersRequest,
      ]);

    const vehiclesUnfiltered = await getVehiclesUnfilteredResponse.json();
    const zones = await getZonesResponse.json();
    const taskConfigIdDict = await getTaskConfigsResponse.json();
    const databaseUsers = await getDatabaseUsersResponse.json();

    dispatch(alertviewSlice.actions.updateVehiclesUnfilteredData(vehiclesUnfiltered));
    dispatch(alertviewSlice.actions.updateZonesData(zones));
    dispatch(alertviewSlice.actions.updateGeofences(zones.geofences));
    dispatch(alertviewSlice.actions.updateNonAcGeofences(zones.nonAcGeofences));
    dispatch(alertviewSlice.actions.updateTaskConfigDict(taskConfigIdDict));
    dispatch(alertviewSlice.actions.updateDatabaseUsers(databaseUsers));
    dispatch(alertviewSlice.actions.updateLoading(false));
  };
}

export {getAlertsData};
export const {updateSortMethod} = alertviewSlice.actions;
export default alertviewSlice.reducer;
